import { DialogLauncher } from '@formstack/phoenix/components/DialogLauncher';

import { MissingProductConnectorDialog } from './MissingProductConnectorDialog';

const launchMissingProductConnectorDialog = () => {
  DialogLauncher.open({
    component: MissingProductConnectorDialog,
  });
};

export { launchMissingProductConnectorDialog };
